import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageSquare } from "lucide-react";
import SmartImage from "./SmartImage";
import { enquireHref } from "../lib/format";

/** Enquiry-only catalogue item (no price / not sold online). */
export default function ItemCard({ item, pageTitle }) {
  const href = `/item/${item.id}`;
  return (
    <article className="card-nq group flex flex-col" data-testid="product-card">
      <Link to={href} className="block overflow-hidden">
        <SmartImage
          src={item.image}
          alt={item.image_alt || item.name}
          ratio="aspect-[4/3]"
          fit="cover"
          fallbackLabel={item.brand || item.name}
          className="transition-transform duration-500 group-hover:scale-[1.03]"
        />
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex items-center gap-2">
          {item.brand && (
            <span
              className="rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
              style={{ background: "rgba(31,107,58,0.28)", color: "var(--nq-sand)" }}
            >
              {item.brand}
            </span>
          )}
          {item.price ? (
            <span className="font-mono text-sm font-semibold gold-text" data-testid="item-price">
              {item.price}
            </span>
          ) : (
            <span
              className="rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider gold-text"
              style={{ borderColor: "rgba(198,162,74,0.35)" }}
              data-testid="item-enquiry-badge"
            >
              Enquiry only
            </span>
          )}
        </div>

        <h3 className="text-base font-semibold leading-snug text-[color:var(--nq-sand)]">
          <Link to={href} className="transition hover:text-[color:var(--nq-gold)]">
            {item.name}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-3 flex-1 text-sm text-[color:var(--nq-stone)]">
          {item.description || "Contact us for details, fitment and pricing."}
        </p>

        <div className="mt-4 flex gap-2">
          <Link
            to={enquireHref({
              type: "item",
              id: item.id,
              title: item.name,
              image: item.image,
              price: item.price,
              category: pageTitle || item.page_title,
              brand: item.brand,
            })}
            className="btn-gold min-h-[44px] flex-1 px-3 py-2.5 text-xs sm:min-h-0 sm:py-2"
            data-testid="product-card-primary-cta"
          >
            <MessageSquare className="h-3.5 w-3.5" /> Enquire now
          </Link>
          <Link
            to={href}
            className="btn-outline-nq min-h-[44px] px-3 py-2.5 text-xs sm:min-h-0 sm:py-2"
            data-testid="product-card-secondary-cta"
          >
            Details <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </article>
  );
}
